import { Container, Row, Col } from "react-bootstrap";
import { HashLink } from "react-router-hash-link";
import {
  Book,
  Cpu,
  People,
  ArrowRightCircle,
} from "react-bootstrap-icons";

const services = [
  {
    number: "01",
    title: "Training Services",
    icon: Book,
    description:
      "Practical training in electro-optical system design, image sensor integration, FPGA development, and embedded image processing.",
  },
  {
    number: "02",
    title: "Turnkey Product Development",
    icon: Cpu,
    description:
      "End-to-end product development from system architecture and sensor selection to FPGA firmware, camera electronics, and application integration.",
  },
  {
    number: "03",
    title: "Consultancy Services",
    icon: People,
    description:
      "Engineering guidance for imaging architectures, component selection, performance optimisation, and product integration.",
  },
];

export const Skills = () => {
  return (
    <section
      className="services-section"
      id="skills"
      aria-labelledby="services-title"
    >
      <Container>

        {/* SECTION HEADING */}
        <div className="services-section__heading">
          <span className="services-section__eyebrow">
            ENGINEERING SERVICES
          </span>

          <h2 id="services-title">
            From expertise to engineered products.
          </h2>

          <p>
            Kristal Fotonik provides expert training and consultancy in
            electro-optical system design, image sensors, and FPGA development.
            From turnkey camera modules to custom image processing units, we
            support every stage of your product development. Reach out to
            Kristal Fotonik for detailed information on our service offerings.
          </p>
        </div>

        {/* SERVICE CARDS */}
        <Row className="g-4">
          {services.map((service) => {
            const ServiceIcon = service.icon;

            return (
              <Col xs={12} md={6} lg={4} key={service.title}>
                <article className="service-card">

                  <div className="service-card__top">
                    <div className="service-card__icon">
                      <ServiceIcon aria-hidden="true" />
                    </div>

                    <span className="service-card__number">
                      {service.number}
                    </span>
                  </div>

                  <h3>{service.title}</h3>

                  <p>{service.description}</p>

                  <HashLink
                    smooth
                    className="service-card__link"
                    to="/#connect"
                    aria-label={`Discuss ${service.title} with our team`}
                  >
                    Discuss This Service
                    <ArrowRightCircle aria-hidden="true" />
                  </HashLink>

                </article>
              </Col>
            );
          })}
        </Row>

      </Container>
    </section>
  );
};